import DOMPurify from 'dompurify'

const ALLOWED_TAGS = ['p', 'br', 'strong', 'em', 'u', 'ul', 'ol', 'li', 'a']

// Configure DOMPurify with secure settings
DOMPurify.setConfig({
  ALLOWED_TAGS,
  ALLOWED_ATTR: ['href', 'target', 'rel'],
  ALLOW_DATA_ATTR: false,
  FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'input', 'button', 'svg', 'math'],
  FORBID_ATTR: ['id', 'name', 'class', 'style', 'onclick', 'onload', 'onerror', 'onmouseover', 'onfocus', 'onblur', 'onchange', 'onsubmit', 'onkeydown', 'onkeyup', 'onkeypress'],
  KEEP_CONTENT: true,
  RETURN_DOM: false,
  RETURN_DOM_FRAGMENT: false,
  RETURN_DOM_IMPORT: false,
  SANITIZE_DOM: true,
  WHOLE_DOCUMENT: false,
  ADD_ATTR: ['target', 'rel'],
  ADD_URI_SAFE_ATTR: [],
  FORBID_CONTENTS: ['script', 'style'],
})

// Add hook to ensure all links are secure
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  // Set target and rel on links
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank')
    node.setAttribute('rel', 'noopener noreferrer')

    // Additional href validation
    const href = node.getAttribute('href')
    if (href) {
      const normalizedHref = href.toLowerCase().trim()
      const forbiddenProtocols = ['javascript:', 'data:', 'vbscript:', 'file:', 'about:']

      if (forbiddenProtocols.some(protocol => normalizedHref.startsWith(protocol))) {
        node.removeAttribute('href')
        node.textContent = '[Link removed for security]'
      }
    }
  }
})

export function sanitizeHtml(html) {
  if (!html) return ''

  try {
    // Use the pre-configured DOMPurify instance
    const clean = DOMPurify.sanitize(html)
    return clean
  } catch (error) {
    console.error('Error sanitizing HTML:', error)
    // Fallback to plain text if sanitization fails
    const div = document.createElement('div')
    div.textContent = html
    return div.innerHTML
  }
}

export function isHtmlContent(text) {
  // Check if the text contains HTML tags
  return /<[^>]+>/.test(text)
}
